import React from 'react';
import { useTranslate } from '../../context/api-context/translations/use-translate';
import ThumbUp from '../reactions/reaction-icon/icons/thumbs-up-icon';
import Heart from '../reactions/reaction-icon/icons/heart-icon';
import { LikeHeart as HeartOutline, ThumbUp as ThumbUpOutline, } from '@wix/wix-ui-icons-common/on-stage';
import AnimatedWrapper from './animated-wrapper';
import { st, classes } from './like-button.st.css';
import { unreachable } from '../../../ts-utils';
const LikeButton = ({ className, isLiked, isDisabled = false, dataHook, config, }) => {
    const t = useTranslate();
    return (React.createElement("button", { onClick: (event) => {
            if (isDisabled) {
                event.preventDefault();
            }
        }, className: st(classes.root, { isDisabled, isLiked }, className), "aria-label": isLiked ? t('like-button.is-liked') : t('like-button.is-unliked'), "data-hook": dataHook }, (() => {
        switch (config.mainEmotion) {
            case 'thumbsup':
                return (React.createElement(AnimatedWrapper, { className: classes.iconContainer, isActive: isLiked, color: "#FFCD00" }, isLiked ? (React.createElement(ThumbUp, { style: { width: '17px', marginBottom: '2px' } })) : (React.createElement(ThumbUpOutline, { className: classes.iconOutline }))));
            case 'heart':
                return (React.createElement(AnimatedWrapper, { className: st(classes.iconContainer, classes.heartContainer), isActive: isLiked, color: "#F5592D" }, isLiked ? (React.createElement(Heart, { style: { width: '17px' } })) : (React.createElement(HeartOutline, { className: classes.iconOutline }))));
            default:
                throw unreachable(config.mainEmotion);
        }
    })()));
};
export default LikeButton;
//# sourceMappingURL=like-button.js.map